<template>
  <div
    v-if="brandRecommendIsLoad && brandRecommendData.length > 0"
    class="other-recommend brand-recommend"
  >
    <span class="other-recommend-title">更多{{ brandRecommendData[0].Brand?.Name }}商品</span>

    <Carousel
      class="recommend-slide"
      :items-to-show="3.5"
      :breakpoints="breakpoints"
      @slide-start="slideStart"
      @slide-end="slideEnd"
    >
      <Slide v-for="r in brandRecommendData" :key="r.MarketID">
        <div class="item-img-box">
          <WishBtn
            :wish-active="r.Colors[0].IsFavorite"
            :custommarket-id="r.Colors[0].CustomMarketID"
            :product-name="r.Name"
            :product-sell-price="r.EventPrice > 0 ? r.EventPrice : r.SellPrice"
            :selected-color="r.Colors[0].ColorName"
          />
          <a class="item-share" @click.prevent="share(r.MarketID)">
            <i class="icon-share" />
          </a>
          <a class="item-img" @click.prevent="slickPush(r.Colors[0].MarketUrl)">
            <NewImage :url="r.Colors[0].Covers[0]" :size="'_w320_h408'" :name="r.Name" />
            <div class="brand-name">{{ r.Brand?.Name }}</div>
            <div class="product-name">{{ r.Name }}</div>
            <div class="product-price">
              <span v-if="r.EventPrice > 0 || r.SellPrice !== r.OriginPrice" class="origin-price">
                NT.{{ r.OriginPrice }}
              </span>
              <span class="sell-price">
                NT.{{ r.EventPrice > 0 && r.EventPrice < r.SellPrice ? r.EventPrice : r.SellPrice }}
              </span>
            </div>
          </a>
          <div class="tag-block">
            <div class="tag-label">
              <span
                v-for="(label, index) in r.Labels"
                :key="index"
                class="d-none d-md-inline-block"
              >
                {{ label.Description }}
              </span>
              <span v-if="r.Labels.length" class="d-md-none">{{ r.Labels[0].Description }}</span>
            </div>
            <a
              v-if="r.Pattern === 2"
              class="open-dialog"
              @click.prevent="openFoodDialog(r.MarketID, '產品內頁')"
            >
              <i class="icon-add-cart" />
            </a>
            <a
              v-else
              class="open-dialog"
              @click.prevent="openDialog(r.Colors[0].CustomMarketID, '產品內頁')"
            >
              <i class="icon-add-cart" />
            </a>
          </div>
        </div>
      </Slide>

      <template #addons>
        <Navigation>
          <template #next>
            <a class="arrow" @click="fireGAEvent('next')">
              <img
                class="img-fluid"
                src="https://static.tpx.tw/sff/urliving/static/img/arrow-right.svg"
              />
            </a>
          </template>
          <template #prev>
            <a class="arrow" @click="fireGAEvent('previous')">
              <img
                class="img-fluid"
                src="https://static.tpx.tw/sff/urliving/static/img/arrow-left.svg"
              />
            </a>
          </template>
        </Navigation>
      </template>
    </Carousel>
    <ShareModal :is-open="isOpen" :link="link" @closeSelf="closeSelf" />
  </div>
</template>

<script setup>
import { ref, watch, nextTick, computed } from 'vue';
import $ from 'jquery';
import 'bootstrap';
import { Carousel, Navigation, Slide } from 'vue3-carousel';
import { fireRecommendClickGAEvent, fireRecommendViewGAEvent } from '@global/gtm/product';

import { storeToRefs } from 'pinia';
import useShopContentStore from '@global/stores/useShopContentStore';

import useSetEnv from '@global/composable/useSetEnv';
import useDialog from '@composable/useDialog';
import useModalStore from '@global/stores/useModalStore';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

import NewImage from '@global/components/common/Image/NewImage.vue';
import WishBtn from '@components/WishBtn.vue';
import ShareModal from '@components/ShareModal.vue';

const modalStore = useModalStore();
const { openModal } = modalStore;

const { setEnv } = useSetEnv();
const { getShareAPI } = useAxiosAPI();
const { openDialog, openFoodDialog } = useDialog();

const isOpen = ref(false);
const link = ref('');

const shopContentStore = useShopContentStore();
const { brandRecommendData, brandRecommendIsLoad, selectedFoodSpec, itemDatas } =
  storeToRefs(shopContentStore);

watch(brandRecommendIsLoad, (val) => {
  if (val && brandRecommendData.value.length) {
    fireRecommendViewGAEvent({
      itemListName: `${window.CustomMarketID.split('SZ')[0]} 品牌推薦產品列表`,
      recommendData: brandRecommendData.value,
    });
  }
});

const breakpoints = computed(() => {
  const setting = {
    768: {
      itemsToShow: 3.55,
      snapAlign: '',
    },
  };
  if (brandRecommendData.value.length >= 4) {
    setting['768'].snapAlign = 'center';
  } else {
    setting['768'].snapAlign = 'left';
  }

  return setting;
});

const nowSlide = ref(false);
function slideStart() {
  nowSlide.value = true;
}
function slideEnd() {
  nowSlide.value = false;
}

function slickPush(url) {
  if (nowSlide.value) return;
  window.location.href = url;
}

const isMobile = setEnv.myEquipment();
function share(id) {
  getShareAPI(id)
    .then((res) => {
      if (res.data.Code === 200) {
        link.value = res.data.Response.Link;

        nextTick(() => {
          if (!isMobile) {
            openModal('ShareModal', link.value);
          } else {
            isOpen.value = true;
          }
        });
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function closeSelf() {
  link.value = '';
  if (isMobile) {
    isOpen.value = false;
  }
}

function fireGAEvent(direction) {
  fireRecommendClickGAEvent({
    recommendedType: '產品內頁',
    recommendedMove: direction === 'previous' ? '推薦商品 More 左箭頭' : '推薦商品 More 右箭頭',
    itemListName: '品牌推薦產品列表',
    recommendedData: brandRecommendData.value,
    productId: window.CustomMarketID,
    productName: window.Pattern === 2 ? selectedFoodSpec.value.Product?.Name : itemDatas.value.Name,
  });
}
</script>
